import { DateField, ArrayField, Datagrid, FunctionField } from "react-admin";
import { Typography } from "@mui/material";
import { getFile } from "server/components/DownloadFile";
import React from "react";

const DocumentFilesArray = ({ filesData, notify }) => {
  if (!filesData?.files || filesData.files.length === 0) return null;

  return (
    <ArrayField
      source="files"
      label="Файлове"
      record={{ files: filesData.files }}
    >
      <Datagrid
        rowClick={false}
        bulkActionButtons={false}
        resource="documents"
        sx={{ margin: 4 }}
      >
        <DateField
          label="Валиден от"
          source="validFrom"
          locales="bg-BG"
        />
        <DateField
          label="Дата на качване"
          source="uploadedAt"
          locales="bg-BG"
          showTime
        />
        <FunctionField
          label={"Свали документ на български"}
          render={bgFile => (
            <Typography
              sx={{ textDecoration: "underline", fontSize: "14px", cursor: "pointer" }}
              onClick={() => getFile(bgFile.bgFileId, notify ? notify : "", "static")}
            >
              {`declaration-bgfile-${bgFile.bgFileId}`}
            </Typography>
          )}
        />
        <FunctionField
          label={"Свали документ на английски"}
          render={enFile => (
            <Typography
              sx={{ textDecoration: "underline", fontSize: "14px", cursor: "pointer" }}
              onClick={() => getFile(enFile.enFileId, notify ? notify : "", "static")}
            >
              {`declaration-enFile-${enFile.enFileId}`}
            </Typography>
          )}
        />
      </Datagrid>
    </ArrayField>
  );
};

export default DocumentFilesArray;
